export interface ReviewWithUser {
  id: string;
  guru_id: string;
  reviewer_id: string;
  session_id: string;
  rating: number;
  review_text: string;
  is_verified: boolean;
  created_at: string;
  updated_at: string;
  reviewer_name?: string;
  reviewer_avatar?: string;
  formatted_date: string;
}

export const exampleReviews: ReviewWithUser[] = [
  {
    id: '1',
    guru_id: 'guru-1',
    reviewer_id: 'user1',
    session_id: 'session1',
    rating: 5,
    review_text: 'Excellent consultation! Dr. Sarah was very knowledgeable and took the time to explain everything clearly. Highly recommend!',
    is_verified: true,
    created_at: '2024-01-15T10:30:00Z',
    updated_at: '2024-01-15T10:30:00Z',
    reviewer_name: 'John Smith',
    reviewer_avatar: 'https://ui-avatars.com/api/?name=John+Smith&background=6366f1&color=fff&size=128',
    formatted_date: 'January 15, 2024'
  },
  {
    id: '2',
    guru_id: 'guru-1',
    reviewer_id: 'user2',
    session_id: 'session2',
    rating: 4,
    review_text: 'Great session, very helpful advice for managing my diabetes. Would book again.',
    is_verified: true,
    created_at: '2024-01-10T14:20:00Z',
    updated_at: '2024-01-10T14:20:00Z',
    reviewer_name: 'Maria Garcia',
    reviewer_avatar: 'https://ui-avatars.com/api/?name=Maria+Garcia&background=6366f1&color=fff&size=128',
    formatted_date: 'January 10, 2024'
  },
  {
    id: '3',
    guru_id: 'guru-1',
    reviewer_id: 'user3',
    session_id: 'session3',
    rating: 5,
    review_text: 'Outstanding experience! The nutrition plan provided was exactly what I needed.',
    is_verified: false,
    created_at: '2024-01-05T09:15:00Z',
    updated_at: '2024-01-05T09:15:00Z',
    reviewer_name: 'David Wilson',
    reviewer_avatar: 'https://ui-avatars.com/api/?name=David+Wilson&background=6366f1&color=fff&size=128',
    formatted_date: 'January 5, 2024'
  }
]; 